import { Element } from "@js/extends";

import Choices from "choices.js";

export default class Select extends Element {
	mounted() {
		this.select = this.el;

		this.initSelect();
	}

	initSelect() {
		new Choices(this.select, {
			placeholder: true,
			searchEnabled: false,
			shouldSort: false,
			classNames: {
				containerOuter: "a-select__outer",
				containerInner: "a-select__inner",
				input: "a-select__input",
				inputCloned: "a-select__input-cloned",
				list: "a-select__list",
				listItems: "a-select__list-items",
				listSingle: "s-field",
				listDropdown: "a-select__list-dropdown",
				item: "a-select__item",
				itemSelectable: "a-select__item-selectable",
				itemDisabled: "a-select__item-disabled",
				itemChoice: "a-select__item-choice",
				placeholder: "a-select__placeholder",
				group: "a-select__group",
				groupHeading: "a-select__group-heading",
				button: "a-select__button",
			},
		});
	}
}
